import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HowSipWorksV2Component } from './how-sip-works-v2.component';



@NgModule({
  declarations: [
    HowSipWorksV2Component
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HowSipWorksV2Component
  ]
})
export class HowSipWorksV2Module { }
